import catalogue from "./icon-catalogue.data";

export interface WebsiteIcon {
  id: string;
  label: string;
  keywords: string;
  category: string;
  brand: boolean;
  viewBox: string;
  paths: string[];
}
export const ICON_CATALOGUE_VERSION = catalogue.version;
export const WEBSITE_ICONS: readonly WebsiteIcon[] = catalogue.icons;
const iconsById = new Map(WEBSITE_ICONS.map((icon) => [icon.id, icon]));
export function websiteIcon(value: unknown): WebsiteIcon | undefined {
  return typeof value === "string" ? iconsById.get(value) : undefined;
}
/** null deliberately hides an icon; absent/unknown values retain the existing renderer. */
export function hasWebsiteIcon(value: unknown): boolean {
  return value === null || websiteIcon(value) !== undefined;
}
export const LEGACY_ICON_IDS: Record<string, string> = {
  search: "magnifying-glass",
  home: "house",
  mail: "envelope",
  phone: "phone",
  user: "user",
  calendar: "calendar-days",
  star: "star",
  check: "check",
  list: "list",
  location: "location-dot",
  arrow: "arrow-right",
  diamond: "star",
  circle: "circle-check",
  x: "x-twitter",
};
export function defaultWebsiteIcon(value: unknown): string | undefined {
  return typeof value === "string"
    ? (LEGACY_ICON_IDS[value] ?? websiteIcon(value)?.id)
    : undefined;
}
const normalise = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/æ/g, "ae")
    .replace(/ø/g, "o");
export function searchWebsiteIcons(
  query: string,
  scope: "general" | "brands" = "general",
  category?: string,
): WebsiteIcon[] {
  const terms = normalise(query).trim().split(/\s+/).filter(Boolean);
  return WEBSITE_ICONS.filter(
    (icon) =>
      icon.brand === (scope === "brands") &&
      (!category || icon.category === category) &&
      terms.every((term) =>
        normalise(`${icon.label} ${icon.keywords} ${icon.id}`).includes(term),
      ),
  );
}
